import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import type Mithril from 'mithril';

export default class Member extends Component {
  oninit(vnode: Mithril.Vnode) {
    super.oninit(vnode);

    const loggedin = app.session.user;

    // document.body öğesinin hazır olduğundan emin olalım
    const body = document.body;

    if (body) {
      // Eğer kullanıcı giriş yapmışsa 'logged-in', yapmamışsa 'logged-out' ekle
      if (loggedin) {
        body.classList.add('logged-in');
      } else {
        body.classList.add('logged-out');
      }
    }
  }

  view() {
    return;
  }
}
